// Empire Jamaica Fusion — About page editorial data
// Voice: New Yorker profile + Hudson Valley editorial.
// No restaurant marketing-speak. Short sentences. Concrete details.

export const STORY_PARAGRAPHS = [
    "Michelle grew up in Kingston, where Sunday cooking wasn’t a meal. It was an event. Pots simmering since dawn. Neighbors stopping by because they smelled the curry. The house full by the time the rice and peas were done.",
    "She brought all of that with her to the Hudson Valley. Not as nostalgia, but as a way of doing things.",
    "It started small. A stack of printed flyers. A few menus passed around. Within days the phone wouldn’t stop ringing. People weren’t just hungry for Jamaican food. They were hungry for what came with it: the warm voice on the phone, the way she remembered orders by name, the unmistakable feeling that someone genuinely cared whether they ate well that night.",
    "The recipes are her grandmother’s. Pimento wood for the jerk. Two hours for the oxtail. Scotch bonnet and coconut handled with the kind of patience you can’t fake or shortcut.",
    "But what guests come back for, again and again, isn’t only the food. It’s the room. The way Michelle walks the floor like every table is family she grew up across the street from. The way regulars end up at the seat by the window. The way new guests leave already planning to return.",
];

export const PULL_QUOTE = {
    text: "The recipes mattered. But how people felt when they walked through the door mattered even more.",
    attribution: "Michelle, Founder",
};

export const PILLARS = [
    {
        id: "hospitality",
        title: "Hospitality that feels personal.",
        body:
            "Michelle is in the room. She remembers your name, your order, the kids you brought last year. There’s no script here. Only the welcome she was raised inside.",
        image:
            "https://customer-assets.emergentagent.com/job_caribbean-premium/artifacts/algcp3ha_04DCB600-D055-49ED-AC04-941FD249AA1D.PNG",
    },
    {
        id: "tradition",
        title: "Food rooted in tradition.",
        body:
            "Family recipes carried from Kingston. Slow-braised, hand-plated, seasoned by patience. We don’t soften the food for the room. We let the room come find it.",
        image:
            "https://customer-assets.emergentagent.com/job_b8a7810c-24f2-4266-91d4-0b33b2eb0b66/artifacts/wfwhbttq_20E119FE-48F8-4837-A259-B87021DF969B.PNG",
    },
    {
        id: "gatherings",
        title: "Gatherings worth remembering.",
        body:
            "Birthdays, anniversaries, christenings, baby showers, and the quiet Tuesday dinners nobody wanted to end. Every one of them was the most important table that night.",
        image:
            "https://customer-assets.emergentagent.com/job_caribbean-premium/artifacts/lldhlwvh_4D544B4D-5ED1-4118-B68A-2CABF55656D8%202.PNG",
    },
];

export const REVIEWS = [
    {
        name: "Saeed Mustafa",
        meta: "Google review",
        rating: 5,
        text:
            "During my 30 year career in the United States military I have had the opportunity to taste some delicious cuisine from incredible restaurants around the world. I am so happy to have found Empire Jamaican Fusion in Poughkeepsie, that in my opinion is a World Class experience. The food was amazing, the customer service was outstanding, the atmosphere was wonderful, and the price was right! I highly recommend everyone who is near to this location, make time to go visit this incredible restaurant first chance you get. I definitely will be back as soon as possible…HOOAH!",
    },
    {
        name: "Veronica Lopez",
        meta: "Google review",
        rating: 5,
        text:
            "The owner went above and beyond to make us feel at home. The food was amazing! I would 100% recommend and when we are back in this area, we will be coming back to eat here. The taste is authentic and delicious. Even the mint and cucumber water she gave us was tasty and refreshing. Thank you Michelle for your kind words and you are a superstar!",
    },
    {
        name: "Farhana Shahid",
        meta: "Google review",
        rating: 5,
        text:
            "We came here for lunch on a road trip and they were kind enough to let us in for lunch even though they were closed before the full service. The food is amazing and the host is lively and very sweet. The food felt like home. It’s one of the amazing jerk chickens we have had in a while. They also had great vegan options made with amazing jerk spices. Highly recommended!",
    },
    {
        name: "Melvin Walker Jr",
        meta: "Google review",
        rating: 5,
        text:
            "The food was great. It was like I was eating at a family home in Jamaica. I could taste the love, and I appreciated the thoughtfulness with how the food was presented. Look to come back again.",
    },
    {
        name: "Moses Lucien",
        meta: "Google review",
        rating: 5,
        text:
            "I haven’t had jerk salmon in years and since Michelle says they make their fish options to order, I opted to wait. I was pleasantly surprised. Everything was cooked to perfection and had that home cooked touch. If you haven’t dined in, make sure you try it sometime. It was a warm and welcoming atmosphere.",
    },
    {
        name: "Joy Nash",
        meta: "Google review",
        rating: 5,
        text:
            "What a wonderful little restaurant! We found it looking for vegan options, the vegan chicken was delicious. Meat eaters in our party enjoyed the bourbon chicken. Friendly service, cozy atmosphere, and parking nearby wasn’t difficult. Highly recommended!",
    },
];

export const COMMUNITY_LINES = [
    "First date.",
    "Got engaged at table six.",
    "Brought the baby.",
    "Now the baby orders for herself.",
    "Sunday regulars.",
    "Office dinner.",
    "Mom’s 70th.",
    "Just because.",
];
